export const roleMiddleware = (roles) => {
  // 创建新的角色对象，避免修改原始数据
  const processedRoles = { ...roles };

  // 处理 electricity 权限
  if (processedRoles.electricity_feature_full === 3) {
    processedRoles.electricity = 3;
  } else if (processedRoles.electricity_feature_editable === 3) {
    processedRoles.electricity = 2;
  } else if (processedRoles.electricity_feature_readonly === 3) {
    processedRoles.electricity = 1;
  } else {
    processedRoles.electricity = 0;
  }

  // 处理 gas 权限
  if (processedRoles.gas_feature_full === 3) {
    processedRoles.gas = 3;
  } else if (processedRoles.gas_feature_editable === 3) {
    processedRoles.gas = 2;
  } else if (processedRoles.gas_feature_readonly === 3) {
    processedRoles.gas = 1;
  } else {
    processedRoles.gas = 0;
  }

  // 处理 equipment 权限
  if (processedRoles.equipment_feature_full === 3) {
    processedRoles.equipment = 3;
  } else if (processedRoles.equipment_feature_editable === 3) {
    processedRoles.equipment = 2;
  } else if (processedRoles.equipment_feature_readonly === 3) {
    processedRoles.equipment = 1;
  } else {
    processedRoles.equipment = 0;
  }

  // 处理 workorder 权限
  if (processedRoles.workorder_feature_full === 3) {
    processedRoles.workorder = 3;
  } else if (processedRoles.workorder_feature_editable === 3) {
    processedRoles.workorder = 2;
  } else if (processedRoles.workorder_feature_readonly === 3) {
    processedRoles.workorder = 1;
  } else {
    processedRoles.workorder = 0;
  }

  return processedRoles;
}